import { html } from 'lit-html';
import { PromotionDisplayType } from '../../../models/item';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';

/**
 * 販促ラベル生成
 * @param promotionDisplayType 販促ラベル区分
 */
export const PromotionDisplay = (promotionDisplayType: PromotionDisplayType) => html`
  <div class="m-simpleitemcard_tag">${PromotionDisplayTag(promotionDisplayType)}</div>
`;

/**
 * 販促ラベル生成（バリエーション画面のみ）
 * @param promotionDisplayType 販促ラベル区分
 */
export const PromotionDisplayWithButton = (promotionDisplayType: PromotionDisplayType) => html`
  <div class="m-itemcard_tag">${PromotionDisplayTag(promotionDisplayType)}</div>
`;

/**
 * 販促ラベル生成（RR左サイド表示用）
 * @param promotionDisplayType 販促ラベル区分
 * @returns 販促ラベル表示内容(NO_DISPLAYの場合空を返却)
 */
export const LeftSidePromotionDisplay = (promotionDisplayType: PromotionDisplayType) => {
  if (promotionDisplayType === PromotionDisplayType.NO_DISPLAY) {
    return html``;
  }
  return html`
    <div class="m-simpleitemcard_tag">${PromotionDisplayTag(promotionDisplayType)}</div>
  `;
};

/**
 * 販促ラベル(単品)
 * 販促ラベル区分を判定して販促ラベルを返却する
 * @param promotionDisplayType 販促ラベル区分
 */
const PromotionDisplayTag = (promotionDisplayType: PromotionDisplayType) => {
  if (promotionDisplayType === PromotionDisplayType.ASKUL_ORIGINAL) {
    return html`<span class="a-tag -bgOriginal -emphasis">
      <span class="a-icon -size16">
        <img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_askul_people.svg"}" alt="" width="16" height="16" />
      </span>
      オリジナル
    </span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.NEW_ARRIVALS_PRODUCT) {
    return html`<span class="a-tag -bgOrange -emphasis">新着</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.NO_DISPLAY) {
    return html`<span class="a-tag"></span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.OUTLET) {
    return html`<span class="a-tag -bgRed -emphasis">アウトレット</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.PERIOD_LIMITED_PRICE_CUT) {
    return html`<span class="a-tag -bgBrown -emphasis">期間限定価格</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.POPULAR_PRODUCT) {
    return html`<span class="a-tag -bgOrange -emphasis">人気商品</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.PRICE_DOWN) {
    return html`<span class="a-tag -bgBrightpink -emphasis">プライスダウン</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.SPECIAL_PRICE) {
    return html`<span class="a-tag -bgDarkgreen -emphasis">わけあり特価</span>`;
  }
  if (promotionDisplayType === PromotionDisplayType.CB_ITEM) {
    return html`<span class="a-tag -bgOriginal -emphasis">メーカーコラボ</span>`;
  }
  return html`<span class="a-tag"></span>`;
};
